import React from 'react';
// @ts-ignore
import styles from './Table.module.scss';
import { ITable } from '../../Models/Table/ITable';
import { joinClasses } from '../../Utils/className.util';
import TableColumns from './TableColumns';
import TableRows from './TableRows';

const Table: React.FC<ITable> = (props: ITable) => {
	const { columns, rows, showColumns = false } = props;

	const fixedColumns = columns.filter(({ fixed }) => fixed);
	const scrollableColumns = columns.filter(({ fixed }) => !fixed);
	const rowsToShow = rows.filter(({ show }) => show);

	return (
		<div className={styles.wrapper}>
			<div className={styles.fixed}>
				{showColumns && (
					<div
						className={joinClasses([styles.flexTable, styles.flexWrap])}
						role='rowgroup'>
						<TableColumns columns={fixedColumns} />
					</div>
				)}
				<TableRows rows={rowsToShow} columns={fixedColumns} />
			</div>
			<div className={styles.scrollable}>
				{showColumns && (
					<div
						className={joinClasses([styles.flexTable, styles.flexWrap])}
						role='rowgroup'>
						<TableColumns columns={scrollableColumns} />
					</div>
				)}
				<TableRows rows={rowsToShow} columns={scrollableColumns} />
			</div>
		</div>
	);
};

export default Table;
